/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Block_YellowInputs */

const en_orders_review_block_yellow = /** @type {(inputs: Orders_Review_Block_YellowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order is marked yellow. Resolve the change before shipping.`)
};

const es_orders_review_block_yellow = /** @type {(inputs: Orders_Review_Block_YellowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El pedido esta marcado en amarillo. Resuelve el cambio antes de enviarlo.`)
};

/**
* | output |
* | --- |
* | "Order is marked yellow. Resolve the change before shipping." |
*
* @param {Orders_Review_Block_YellowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_block_yellow = /** @type {((inputs?: Orders_Review_Block_YellowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Block_YellowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_block_yellow(inputs)
	return es_orders_review_block_yellow(inputs)
});